import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.css';
import './index.css';

import {
    // Grid,
    // Row,
    // Col,
    FormGroup,
    // InputGroup,
    ControlLabel,
    FormControl,
    HelpBlock
} from "react-bootstrap";

import Button from "components/CustomButton/CustomButton.jsx";

import { auth, db } from "firedb/firebase";

import * as routes from 'constants/routes';

const init_state = {
	UserEmail : '',
	UserEmailValid: null,
	HelpUserEmail: '',
	EmailSent: false,
	ButtonPushed: false,
	ErrorMsg: ''
};

class PasswordForgetPage extends Component {
	constructor(props) {
		super(props);

		this.state = {...init_state};

		this.onChangeUserEmail = this.onChangeUserEmail.bind(this);
		this.onClickRestore = this.onClickRestore.bind(this);
	}

	onChangeUserEmail(event) {
        this.setState({UserEmail : event.target.value});
    }

	onClickRestore() {
		this.setState({ButtonPushed: true});
		auth.sendPasswordResetEmail(this.state.UserEmail)
			.then(() => {
				this.setState({EmailSent: true});
				this.setState({ErrorMsg: ''});
			})
			.catch((error) => {
				switch (error.code) {
					case 'auth/invalid-email':
						this.setState({ErrorMsg: "Неправильный Email"});
						this.setState({ButtonPushed: false});
						break;

					case 'auth/user-not-found':
						this.setState({ErrorMsg: "Пользователь с таким Email не существует"});
						this.setState({ButtonPushed: false});
						break;

					default:
						this.setState({ErrorMsg: "Произошла ошибка, попробуйте позже"})
						this.setState({ButtonPushed: false});
						break;
				}
			})
	}

	render() {
		return (
			<div className="content container-sign">

			<div className="login-box-body">
		        <p className="h2 text-center">НАКОПИ!</p>
		        <p className="login-box-msg text-center text-muted">Восстановление пароля</p>
	            
				<div className={this.state.EmailSent ? 'body-sign login-box-msg' : 'hidden'}>
					<p className="login-box-msg text-center">
						На ваш почтовый ящик отправлена ссылка для восстановления пароля.
					</p>
				</div>

	            <div className={this.state.ButtonPushed ? 'hidden' : ''}>
	                <div className="col-md-12 item-sign-email">
	                	<FormGroup validationState={this.state.UserEmailValid}>
                            {/*<ControlLabel>Ваш E-Mail</ControlLabel>*/}
                            <FormControl
                                type="text"
                                bsClass="form-control"
                                placeholder="Ваш E-Mail"

                                value={this.state.UserEmail}
								onChange={this.onChangeUserEmail}
                            />
                        	<HelpBlock>{this.state.ErrorMsg}</HelpBlock>

	                    </FormGroup>
	                </div>

					{/*<div className="row">*/}
						<div className="col-xs-12 no-padding login-page-bttn">
							<Button   
	                            type="submit"
	                            className="btn btn-primary btn-block btn-flat" 

								onClick={this.onClickRestore}
							>
							   Восстановить пароль
							</Button>
						</div>
					{/*</div>*/}

				</div>
				<div className="row">
					<div className="col-xs-12 no-padding login-page-bttn">
                		<a href="/" className="login-page-i-forgive-passwd" >Вернуться</a><br />
            		</div>
				</div>
	            
	        </div>
			</div>
		)
	}
}

const buttonStyles = { maxWidth: 400, margin: '0 auto 10px' };

export default withRouter(PasswordForgetPage);


// WEBPACK FOOTER //
// ./src/components/SignIn/PasswordForget.jsx